import React, { useState, useEffect, useRef } from 'react'
import store from "@/redux/store";
import { v4 as uuid } from "uuid";
import {hideModal, detailDossier as detailDossierModal} from "@/reducers/ModalPopup";    
import {quickSearch, setTaskKey} from "@/reducers/Dossier"
import moment from 'moment';
import { useTranslation, withTranslation, Trans } from "react-i18next";
import { open, close, setPos } from '@/reducers/Window'
import DateHelperClass from '@/helpers/DateHelper'

import {
  Combobox,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  Dialog,
  DialogPanel,
  DialogBackdrop,
} from '@headlessui/react'
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import { DocumentPlusIcon, FolderIcon, FolderPlusIcon, HashtagIcon, TagIcon, CalendarDaysIcon } from '@heroicons/react/24/outline'
import { useNavigate, Link } from "react-router-dom";
        

export function CalenderPanel({...props}) {
    const [searchtxt, setSearchTxt] = useState(null);  
    const [query, setQuery] = useState([])  
    const currentEventRef = useRef(null);
    const navigateTo = useNavigate();
const { t, i18n, ready } = useTranslation();

let calenderEvents = store.getState().AuthReducer.calenderEvents;
let todos = ( calenderEvents.where('type', 1).get() );

//to={getDossierLink(project)}
    return (
        <>
            <div ref={currentEventRef} className="cursor-pointer w-96 h-full cursor-default rounded-md py-1 px-1.5 pr-3 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 ">

               <div className="grid grid-cols-12 grid-rows-3 relative w-full gap-x-12 gap-y-0" >
               <div className="row-span-2 col-span-auto">
<CalendarDaysIcon 
aria-hidden="true"
className="pointer-events-none  mr-2 size-6 self-center justify-self-end text-gray-500 sm:size-10"
/>
               </div>
                <span className="col-start-2 col-span-8 row-start-1 w-full outline-none outline bg-transparent pr-4 text-base text-gray-900 outline-hidden placeholder:text-gray-500 sm:text-sm">
                Vandaag {DateHelperClass.getCurrent('DD MMM YYYY') as string} 
                </span>
                <span className="col-start-2 col-span-8 row-start-2 w-full outline-none outline bg-transparent pr-4  text-base text-gray-900 outline-hidden placeholder:text-gray-500 sm:text-sm">
                 - {(todos && todos.length >= 1) ? todos.length+" todo taken" : 'Geen TODO taken'} 
                </span>
                <span className="hidden col-start-2 col-span-8 row-start-3 w-full outline-none outline bg-transparent pr-4  text-base text-gray-900 outline-hidden placeholder:text-gray-500 sm:text-sm">
                 - 3 todo taken
                </span>
                
                </div>
                

            </div>
        </>
      );    
}
